import Vue from 'vue'
import VueRouter from 'vue-router'
import Projects from '@/views/Projects.vue';
import Resume from '@/views/Resume.vue';
import Blog from '@/views/Blog.vue';
import Contact from '@/views/Contact.vue';
import Test from '@/views/Test.vue';

Vue.use(VueRouter);

let isMobile = window.outerWidth <= 550;

const routes = [/*{
    path: '/test',
    name: 'test',
    component: Test,
  }, */{
    path: '/home',
    name: 'projects',
    component: Projects,
    meta: {
      memoji: require('../assets/mindblown.png'),
      corner_text: `${isMobile ? '<' : '^' } You right now...\n probably 🤞`
    },
  },
  {
    path: '/resume',
    name: 'resume',
    component: Resume,
    meta: {
      memoji: require('../assets/awesome.png'),
      corner_text: `Get down to business,\nshall we ?`,
      designatedTextX: isMobile ? 7 : null
    }
  }, {
    path: '/contact',
    name: 'contact',
    component: Contact,
    meta: {
      memoji: require('../assets/hmm.png'),
      corner_text: `What's on your\n mind ?`,
      designatedTextX: isMobile ? 12 : null
    }
  }, {
    path: '/blog',
    name: 'blog',
    component: Blog,
    meta: {
      memoji: require('../assets/facepalm.png'),
      corner_text: `You don't really have \nto go through this 😆`,
      designatedTextX: 6
    }
  }, {
    path: '*',
    redirect: '/home'
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    // return desired position
    console.log({savedPosition});
    document.querySelector('.contentScrollTarget').scrollIntoView({ behavior: 'smooth'});
  }
})

export const pages = routes;

export default router